import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TrlVariationLabel } from '»components/atoms';

import { TrlCardNegButtons } from '../TrlCardNegButtons';
import { TrlSimpleChart } from '../TrlSimpleChart';
import {
  VariationContainer,
  VariationLabel,
  Wrapper,
} from './TrlVariation.styles';

export const TrlVariation = ({
  variationPctg,
  chartData,
  isCard,
  isCardMobileDetails,
  canTrade,
  symbol,
  exchange,
  securityType,
  decimalDigits,
}) => (
  <Wrapper isCard={isCard} isCardMobileDetails={isCardMobileDetails}>
    {variationPctg !== null && variationPctg !== undefined && (
      <VariationContainer>
        <TrlSimpleChart
          chartData={chartData}
          symbol={symbol}
          exchange={exchange}
          securityType={securityType}
          isCard={isCard}
          isCardMobileDetails={isCardMobileDetails}
        />

        <VariationLabel
          isCard={isCard}
          isCardMobileDetails={isCardMobileDetails}
        >
          <FormattedMessage
            id={isCard ? 'TRLT_UI-VARIATION_SHORT' : 'TRLT_UI-VARIATION'}
          />
        </VariationLabel>

        <TrlVariationLabel
          variationPctg={variationPctg}
          parent={isCard ? 'card' : isCardMobileDetails && 'cardMobileDetails'}
          decimalDigits={decimalDigits}
        />
      </VariationContainer>
    )}
    {isCard && (
      <TrlCardNegButtons
        canTrade={canTrade}
        symbol={symbol}
        exchange={exchange}
        securityType={securityType}
      />
    )}
  </Wrapper>
);

TrlVariation.propTypes = {
  variationPctg: PropTypes.number.isRequired,
  chartData: PropTypes.array,
  isCard: PropTypes.bool,
  isCardMobileDetails: PropTypes.bool,
  canTrade: PropTypes.string,
  symbol: PropTypes.string,
  exchange: PropTypes.string,
  securityType: PropTypes.string,
  decimalDigits: PropTypes.number.isRequired,
};
